import axios from "axios";
import * as types from "./actionTypes";
import { beginAjaxCall, ajaxCallError } from "./ajaxStatusActions";
import * as alertActions from "./alertActions";
import { navigateToNews } from "./navigationActions";
import { fetchNewsPages } from "./newsPageActions";
import { fetchServices } from "./serviceActions";
import { fetchRewards } from "./rewardActions";
import { fetchMarketingActions } from "./marketingActions";

import ResponseStatus from "../utils/responseStatus";
import newsItemTransformationBeforeSave from "../data-transformations/newsItemTransformationBeforeSave";

export const createNews = data => dispatch => {
  dispatch(beginAjaxCall());

  const transformedData = newsItemTransformationBeforeSave(data);

  axios
    .post(`news`, transformedData)
    .then(response => {
      if (ResponseStatus.IsCreated(response.status)) {
        dispatch({
          type: types.NEWS_ADD
        });

        dispatch(navigateToNews());
      } else {
        dispatch(ajaxCallError());
      }
    })
    .catch(error => {
      dispatch(ajaxCallError());
      throw error;
    });
};

export const updateNews = data => dispatch => {
  dispatch(beginAjaxCall());

  const transformedData = newsItemTransformationBeforeSave(data);

  axios
    .put(`news`, transformedData)
    .then(response => {
      if (ResponseStatus.IsOK(response.status)) {
        dispatch({
          type: types.NEWS_UPDATE,
          data: response.data
        });

        dispatch(navigateToNews());
      } else {
        dispatch(ajaxCallError());
      }
    })
    .catch(error => {
      dispatch(ajaxCallError());
      throw error;
    });
};

export const fetchNewsDependencies = () => async (dispatch, getState) => {
  try {
    dispatch(LOADING_DEPENDENCIES_BEGIN);

    await fetchNewsPages()(dispatch, getState);
    await fetchServices()(dispatch, getState);
    await fetchRewards()(dispatch, getState);
    await fetchMarketingActions()(dispatch, getState);
  } catch (exception) {
    throw exception; //FUJ
  } finally {
    dispatch(LOADING_DEPENDENCIES_END);
  }
};

/*
public enum PushNotificationResultState
    {
        // Uspesne odeslano
        Sent = 0,

        //Stav kdy pri zpracovani neni u nas nalezen subscriber s danym msisdn
        SubscriberNotFound = 1,

        // Token sice mame ale uzivatel nema aktualne registrovany telefon (reinstalace, ...) - aktualne nejde dorucit. Opakovanym pokusem treba ano
        TokenNotFound = 2,

        // Token nemame
        TokenIsEmpty = 3,

        // Neocekavana chyba
        OtherError = 4
    }
*/
export const sendPushNotificationsToBetaTesters = () => async (
  dispatch,
  getState
) => {
  let { table } = getState();
  let { actionUrl, data } = table;
  let { id } = data.find(i => i.selected);

  if (id) {
    axios
      .post(`${actionUrl}/betaTesterPushNotification/${id}`)
      .then(response => {
        const results = response.data.result;
        const sentSuccessfully = results.filter(result => result.state == 1);
        const notSent = results.filter(result => result.state != 1);
        const sentSuccessfullyMessagePrefix = "Úspěšně odesláno na: ";
        const notSentMessagePrefix = "Nepodařilo se odeslat na: ";
        const resultToMessageReducer = (accumulator, currentValue) =>
          accumulator + `${currentValue.msisdn};`;

        if (sentSuccessfully.some(result => result)) {
          const message = sentSuccessfully.reduce(
            resultToMessageReducer,
            sentSuccessfullyMessagePrefix
          );
          dispatch(alertActions.alertSuccessMessageAdd(message));
        }

        if (notSent.some(result => result)) {
          const message = notSent.reduce(
            resultToMessageReducer,
            notSentMessagePrefix
          );
          dispatch(alertActions.alertErrorMessageAdd(message));
        }

        dispatch(navigateToNews());
      })
      .catch(error => {
        ajaxCallError();
        dispatch(alertActions.alertErrorAdd("Chyba, nepodařilo se odeslat push notifikace."));
        throw error;
      });
  }
};

const LOADING_DEPENDENCIES_BEGIN = {
  type: types.NEWS_LOADING_DEPENDENCIES_BEGIN
};

const LOADING_DEPENDENCIES_END = {
  type: types.NEWS_LOADING_DEPENDENCIES_END
};
